<template>
    <footer class="text-center text-black-50 mt-5">
        <p>{{ copyright }}</p>
    </footer>
</template>

<script>
    export default {
        computed: {
            copyright() {
                const CURRENT_YEAR = new Date().getFullYear();
                return `© Assistel ${CURRENT_YEAR} - Tous droits réservés`
            }
        }
    }
</script>
